/* DON'T EDIT THIS FILE: edit original and run build again */ export const getEmailWithName = (email: string, name?: string | null) => {
  if (name) {
    return name + " <" + email + ">";
  }
  return email;
};
